import { useEffect } from 'react';

const useInitUploadData = ({
  file,
  fallbackUrl,
  fallbackName,
  setState
}: {
  file: any;
  fallbackUrl: string;
  fallbackName: string;
  setState: (data: any) => void;
}) => {
  useEffect(() => {
    if (file) {
      setState({
        uid: file.uid,
        name: file.name,
        status: file.status,
        percent: file.percent
      });
    } else if (fallbackUrl) {
      setState({
        uid: '',
        name: fallbackName || '',
        status: '',
        percent: ''
      });
    } else {
      setState(undefined);
    }
  }, [file, fallbackUrl, fallbackName]);
};

export default useInitUploadData;
